// подключаем главную функцию с которой начинается выполнение
import {main} from 'boot';

// конфигурационный файл, определяющий сетевой идентификатор игры
import gameConfig from 'cfg/game-config.js';

// сгенерированная информация о версии игры
import versionInfo from './version';

// функция построения компонентов игры
import construct from './construct';

// графическая метрика пользовательского интерфейса
import uiConfig from 'cfg/userinterface-config';

import screenConfig from 'cfg/screen-config';

import resources from 'res/resources';

console.log(versionInfo.name + " build: " + versionInfo.build + " buildDate: " + versionInfo.buildDate);

/* // политика совершения пользователем выбора в бонусах
var bonusUserSelectionsPolicy = [
    {
        gameType : Server.GAME_TYPE.BONUS_1,
        from : 0,
        to : 4,
        exclusive : true    // выбор пользователя уникален от шага к шагу бонуса
    },
    {
        gameType : Server.GAME_TYPE.BONUS_2,
        from : 0,
        to : 1
        // по-умолчанию выбор пользователя не уникален (на разных шагах бонуса может повторяться)
    }
];
*/

// entry point
main(
    resources,
    construct,
    {
        gameNetworkId:gameConfig.gameNetworkId,
        gameName:versionInfo.name,
        // bonusUserSelectionsPolicy
    },
    {},
    uiConfig,
    screenConfig
);






// WEBPACK FOOTER //
// ./src/main.es6